// extracted by mini-css-extract-plugin
export default {"mealEditInfo":"HUpBFKrr8ULa4gksx4si"};